module.exports = __webpack_public_path__ + "img/new-built.dcf1b744.svg";